import { CRS_CONSTANTS } from '../../pages/constants/crsContants';
import { RiskIndicatorModule } from './apiModules/RiskIndicatorModules/riskIndicatorModule';

const { CRS_BASE_URL, HTTP_HEADERS } = CRS_CONSTANTS;

export class NetworkLayer {
  constructor() {
    this.baseUrl = CRS_BASE_URL;
    this.httpHeaders = HTTP_HEADERS;

    this.riskIndicatorModule = new RiskIndicatorModule(
      CRS_BASE_URL,
      HTTP_HEADERS
    );
  }

  getRiskIndicatorsAPI = async (payload) =>
    await this.riskIndicatorModule.getRiskIndicators(payload);
  getRiskIndicatorThresholdsAPI = async (payload) =>
    await this.riskIndicatorModule.getRiskIndicatorThresholds(payload);
  putRiskIndicatorThresholdAPI = async (payload) =>
    await this.riskIndicatorModule.putRiskIndicatorThreshold(payload);
  deleteRiskIndicatorThresholdAPI = async (payload) =>
    await this.riskIndicatorModule.deleteRiskIndicatorThreshold(payload);
  updateRiskIndicatorThresholdAPI = async (payload) =>
    await this.riskIndicatorModule.updateRiskIndicatorThreshold(payload);
  postRiskIndicatorTriggerAPI = async (payload) =>
    await this.riskIndicatorModule.postRiskIndicatorTrigger(payload);
  getRiskIndicatorStaticPropertiesAPI = async (payload) =>
    await this.riskIndicatorModule.getRiskIndicatorStaticProperties(payload);
}
